import { getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Icon from "@client/controls/Icon/component";
import { Loading } from "@client/controls/Loading/component";
import { IconType } from "@client/types";
import { getTooltipAttributes } from "@common/contexts/Tooltip";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import * as React from "react";
import Sections from "../../Modules/container";
import Lesson from "./Lesson/container";

export type MapProps = RootContainerProps & {
  hasLessons: boolean;
  alignment: "left" | "right";

  isLoading: boolean;
  isExpanded: boolean;
  name: string;
};

export interface ActionProps {
  onItemClick: (lessonId: string) => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  const [isExpanded, setIsExpanded] = React.useState(props.isExpanded);

  React.useEffect(() => setIsExpanded(props.isExpanded), [props.isExpanded]);

  const onToggleExpanded = React.useCallback(() => setIsExpanded(!isExpanded), [isExpanded, setIsExpanded]);

  return (
    <div className={classNames("content", `align_${props.alignment}`, { expanded: isExpanded })}>
      {props.hasLessons ? (
        <>
          <div className={classNames("lesson_wrap", { loading: props.isLoading })}>
            {props.isLoading ? (
              <Loading />
            ) : (
              <>
                <div className="toggle" onClick={onToggleExpanded} {...getTooltipAttributes(i18n.courseContent)}>
                  <Icon
                    iconClassName={
                      isExpanded
                        ? props.alignment === "right"
                          ? IconType.LongArrowLeft
                          : IconType.LongArrowRight
                        : IconType.Arrows
                    }
                  />
                </div>
                {<Lesson {...getRootContainerProps(props)} />}
              </>
            )}
          </div>
          <Sections {...getEntityRef(props)} navigationType="accordion" />
        </>
      ) : (
        <div className="no_lessons">{i18n.infoNoLessons}</div>
      )}
    </div>
  );
};
